module.exports = __webpack_public_path__ + "img/dianzan.8c12808f.png";